"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoize = void 0;
// тк действительно any
var ramda_1 = require("ramda");
// Для предачи объектов и маасивов нужно использование
// tslint:disable-next-line:no-any
var memoize = function (fn) {
    return (0, ramda_1.memoizeWith)(ramda_1.identity, fn);
};
exports.memoize = memoize;
//# sourceMappingURL=memoize.js.map